import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.INCIDENTS].GET_INCIDENTS]: {
		url: '/company/:companyId/incidents/',
	},
	[ModulesConfigMap[ModulesMap.INCIDENTS].GET_INCIDENT_PREVIEW]: {
		url: '/company/:companyId/incidents/:incidentId/preview/',
	},
	[ModulesConfigMap[ModulesMap.INCIDENTS].GET_INCIDENT_POPUP]: {
		url: '/company/:companyId/incidents/:incidentId/popup/',
	},
	[ModulesConfigMap[ModulesMap.INCIDENTS].GET_INCIDENT]: {
		url: '/company/:companyId/incidents/:incidentId/',
	},
	[ModulesConfigMap[ModulesMap.INCIDENTS].CREATE_INCIDENT]: {
		url: '/company/:companyId/incidents/',
		requestOptions: {
			method: 'POST',
		},
	},
	[ModulesConfigMap[ModulesMap.INCIDENTS].PATCH_INCIDENT]: {
		url: '/company/:companyId/incidents/:incidentId/',
		requestOptions: {
			method: 'PATCH',
		},
	},
	[ModulesConfigMap[ModulesMap.INCIDENTS].PATCH_INCIDENT_CLOSE]: {
		url: '/company/:companyId/incidents/:incidentId/close/',
		requestOptions: {
			method: 'PATCH',
		},
	},
	[ModulesConfigMap[ModulesMap.INCIDENTS].PUT_INCIDENT]: {
		url: '/company/:companyId/incidents/:incidentId/',
		requestOptions: {
			method: 'PUT',
		},
	},
	[ModulesConfigMap[ModulesMap.INCIDENTS].DELETE_INCIDENT]: {
		url: '/company/:companyId/incidents/:incidentId/',
		requestOptions: {
			method: 'DELETE',
		},
	},
}
